import React from 'react';
import { useState } from 'react';
import '../App.css';
import '../styles/Home.css';
import HomeHero from '../components/HomeHero';
// import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import imgPodcastCancerSang from '../assets/img/cancer-du-sang-nos-vies.jpg';
import ReactPlayerLoader from '@brightcove/react-player-loader';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Podcast1 from '../components/Podcast/Podcast1';
import Podcast2 from '../components/Podcast/Podcast2';
import Podcast3 from '../components/Podcast/Podcast3';
import Podcast4 from '../components/Podcast/Podcast4';
import { useEffect } from 'react';

function Home() {

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      }
    }
  }, []);

  var podcasts = [
    { color: 'darkPink', duration: '4 min 51', id: 'fin-du-traitement', title1: 'Je termine mon traitement.', title2: 'Qu\'est-ce que ça veut dire ?', description1: 'Entre soulagement et inquiétudes, fatigue persistante, peur de la rechute et besoin de soutien, trouver un nouvel équilibre prend du temps.', description2: 'Pour en savoir plus, écoutez les conseils du Dr E. Ferrant.', podcastId: '6375744825112' },
    { color: 'mediumBlue', duration: '5 min 39', id: 'equilibre-de-vie', title1: 'Comment retrouver mon équilibre de vie ?', title2: 'Qui peut m\'aider ?', description1: 'Cette période peut s\'accompagner de séquelles nécessitant une prise en charge adaptée. L\'évaluation de vos besoins peut impliquer plusieurs professionnels de santé.', description2: 'Le Dr Ferrant vous explique le rôle de chacun.', podcastId: '6375743746112' },
    { color: 'salmon', duration: '5 min 10', id: 'suivi', title1: 'Mon suivi.', title2: 'Quels sont les points auxquels je dois être attentif au quotidien ?', description1: 'Même après l\'arrêt du traitement, un suivi régulier est essentiel pour surveiller l\'évolution de la maladie, prévenir les complications et préserver votre bien-être.', description2: 'Pour mieux en comprendre l\'importance et les principes, écoutez les conseils du Dr S. De Guibert.', podcastId: '6375744446112' },
    { color: 'purple', duration: '6 min 48', id: 'accompagnement', title1: 'En ville ou à l\'hôpital ?', title2: 'Qui va m\'accompagner et comment ?', description1: 'Votre médecin traitant, en lien avec votre hématologue, coordonnera votre suivi. Si nécessaire, et selon votre situation et vos souhaits, vos médecins pourront faire appel à d\'autres spécialistes, en ville ou à l\'hôpital', description2: 'Pour en savoir plus, écoutez le Dr S. De Guibert.', podcastId: '6375744533112' },
  ];
  
  var files = [
    { name: 'Titre du PDF 1', url: '#', description: '' },
    { name: 'Titre du PDF 2', url: '#', description: '' },
    { name: 'Titre du PDF 3', url: '#', description: '' },
    { name: 'Titre du PDF 4', url: '#', description: '' },
  ];

  const podcastComponents = [Podcast1, Podcast2, Podcast3, Podcast4];
  const [show, setShow] = useState(false);
  const [selectedPodcastIndex, setSelectedPodcastIndex] = useState(0);
  const [activePlayerIndex, setActivePlayerIndex] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = (index) => {
    setSelectedPodcastIndex(index);
    setShow(true);
  };

  return (
    <>
      <Helmet>
        <title>AbbVie</title>
        <meta
          name="description"
          content=""
        />
      </Helmet>
      <HomeHero/>
      <div className='container'>
        <h2>Dans la prise en charge des hémopathies malignes, terminer un traitement est une étape essentielle, mais le suivi continue.</h2>
        <p>
          Cette phase de transition peut susciter des interrogations, des doutes ou nécessiter des ajustements.
        </p>
      </div>
      <div className="container">
        {podcasts.map((podcast, index) => (
          <div className="podcast-item" id={`${podcast.id}`} key={index}>
            <div className={`podcast-index ${podcast.color}`}>
              <span className='numPodcast'>{index + 1}</span>
              <span
              className='playbackPodcast'
              onClick={() => {
                console.log(activePlayerIndex);
                console.log(index);
                if (activePlayerIndex === index) {
                  setActivePlayerIndex(null);
                } else {
                  setActivePlayerIndex(null);
                  setActivePlayerIndex(index);
                }
              }}
            >
              Lecture
            </span>
              <span className='textPodcast' onClick={() => handleShow(index)}>Version Texte</span>
            </div>
            <div className={`podcast-content border-${podcast.color}`}>
              <p className='mb-0'><span className="podcast-duration">{podcast.duration}</span></p>
              <h3><strong>{podcast.title1}</strong> <br/> {podcast.title2}</h3>
              <p className='mb-0'>{podcast.description1} <br/> <strong>{podcast.description2}</strong></p>
            </div>
            <Modal show={show} onHide={handleClose} className='ModalPodcast'>
              <Button className='closeModal' onClick={handleClose}>
                <span>Fermer <br/> la version texte</span>
              </Button>
              {React.createElement(podcastComponents[selectedPodcastIndex])}
            </Modal>
          </div>
        ))}

        {activePlayerIndex !== null && (
          <div className={`player-container ${podcasts[activePlayerIndex].color}`}>
            <span className='close' onClick={() => setActivePlayerIndex(null)}><i class="bi bi-x-lg"></i></span>
            <p><strong>{podcasts[activePlayerIndex].title1}</strong></p>
            <ReactPlayerLoader
              accountId={'1029485116001'}
              videoId={podcasts[activePlayerIndex].podcastId}
              attrs={{className: `player-podcast`}}
              playerId={'aViZyTDNS'}
            />
          </div>
        )}
      </div>
      <div className='discover-podcasts-section'>
        <div className="container">
          <img src={imgPodcastCancerSang} alt="Podcast Cancer du Sang" />
          <div>
            <h2>Découvrez aussi les podcasts</h2>
            <p><a href="https://podcast.ausha.co/cancers-du-sang-nos-vies" target="_blank" className="external-link">Cancer du sang, nos vies</a></p>
            <p>Qui donnent la parole aux malades et à tous ceux qui se battent à leur côté : proches, médecins et soignants, associations. Ils ont tous un rôle à jouer pour que la vie continue.</p>
            <p className='mb-0'>Leurs histoires racontent leur combat, leurs victoires et leurs émotions à chaque étape de la maladie.</p>
          </div>
        </div>
      </div>
      <div>
        <div className="container">
          <h2>Documents annexes</h2>          
          <ul className='documents-list'>
            {files.map((file, index) => (
              <li key={index}>
                <a href={file.url}>
                  <strong>{file.name}</strong>
                  <span>Télécharger</span>
                  <span>{file.description}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
   )
}

export default Home;